module.exports = __webpack_public_path__ + "img/login_logo_new.216419f0.png";